<template>
  <section>
    <div>
      <div class="mtbl alram_tbl" style="width:100%;box-sizing:border-box;">
        <table>
            <colgroup>
                <col width="90">
                <col width="*">
            </colgroup>
            <thead>
                <tr>
                    <th class="al" scope="col">종목코드</th>
                    <th class="al" scope="col">종목명</th>
                </tr>
            </thead>
            <tbody>
              <template v-for="(itema, index) in searchPages.items">
                <tr :key="`${index}_1`"
                  :class="`item ${itema.newsSn == viewNewsSn ? 'act' : ''}`"
                  @click="isStates(itema.newsSn)"
                >
                    <td class="ta_c">{{itema.symbol}}</td>
                    <td>
                        <span class="single">{{itema.kwName}}</span>
                    </td>
                </tr>
                <tr :key="`${index}_2`"
                  class="alram_w"
                  :style="`${itema.newsSn == viewNewsSn ? 'display: table-row' : 'display:none'}`"
                >
                    <td colspan="2" class="alram">
                        <strong>{{itema.title}}</strong>
                        <pre class="al_tx">{{itema.contents}}</pre>
                    </td>
                </tr>
            </template>
            </tbody>
        </table>
      </div>
      <div class="more" v-if="'Y' === searchPages.nextPgFlag">
        <a @click="goPage(searchPages.pageNo + 1)" >더보기</a>
      </div>
    </div>
  </section>
</template>

<script>
import axios from 'axios'
import Loading from '@/components/common/Loading'
import commonMixin from '@/mixin/commonMixin.js'

export default {
  mixins: [commonMixin],
  components: {
    Loading
  },
  data () {
    return {
      searchPages: {
        pageNo: 1,
        pageSize: 10,
        totalRows: 0,
        nextPgFlag: 'N',
        items: []
      },
      viewNewsSn: 0
    }
  },
  methods: {
    init () {
      const params = {
        pageNo: this.searchPages.pageNo,
        pageSize: this.searchPages.pageSize
      }
      this.$store.dispatch('setLodingBarSetting', true)

      let postUrl = 'https://security.thinkpool.com/api/us/kw/news/getUsStockDataListAjax.do'
      axios.post(postUrl, params).then((res) => {
        this.searchPages.totalRows = res.data.resObj.totalRows
        this.searchPages.nextPgFlag = res.data.resObj.nextPgFlag
        let len = 0
        if (res.data.resObj.newsList !== undefined) {
          len = res.data.resObj.newsList.length
        }

        for (var i = 0; i < len; i++) {
          this.searchPages.items.push(res.data.resObj.newsList[i])
        }
        this.$store.dispatch('setLodingBarSetting', false)
      })
    },
    goPage (pageNo) {
      this.searchPages.pageNo = parseInt(pageNo)
      this.init()
    },
    isStates (val) {
      if (this.viewNewsSn === val) {
        this.viewNewsSn = 0
      } else {
        this.viewNewsSn = val
      }
    }
  },
  created () {
    this.init()
  }
}
</script>

<style scoped>
  a {
    cursor: pointer
  }
</style>



// WEBPACK FOOTER //
// src/views/kiwoom/usRecord/mb/UsNews.vue